import React from "react"
import ConvertKitForm from "convertkit-react"

const config = {
  formId: 1916168,
  template: 'clare',
  emailPlaceholder: 'Your email...',
  submitText: 'Join ⚡️',
  hideName: true,
  stack: false,
  newTab: false,
}

const Subscribe = (props) => {
  const { hideExplainer } = props
  return (
    <div className="subscribe">
      <h1>Join Elbaum's World 🌎</h1>
      {
        hideExplainer 
        ? null
          : <p>The first Sunday of every month, I write an email with updates from my path to sustainable self-employment, plus links to my new articles, tweets, videos and other favorites. I'd love for you to join!</p>
      }
      <ConvertKitForm {...config} />
    </div>
  )
}

export default Subscribe